import React from 'react';
import { formatNumWithDecimal } from '../../../../common/constants/formatNumWithDecimal';

const BankSlabColumnData = changeMonth => {
  const commonHeaderStyle = 'items-end mx-auto ',
    commonStyle = 'w-full mx-3',
    commonparentGruopStyle =
      '  mx-auto text-center  mb-2 text font-khand font-sm text-black-500 font-semibold absolute ',
    commonColStyle =
      ' mt-2 text-black-500 text-sm  font-khand font-normal overflow-auto';

  const commonParentGroupStyle = {
    fontWeight: 500,
    fontSize: '14px',
    bottom: '34px'
  };
  const colStyle = { fontWeight: '500', opacity: '0.8' };

  const HeaderCommonFormat = ({
    majorColName = '',
    colName,
    colNameClass = '',
    passclass = ''
  }) => (
    <div className={`${commonHeaderStyle} ${passclass}`}>
      <p
        className={`${commonparentGruopStyle} `}
        style={commonParentGroupStyle}
      >
        {majorColName}
      </p>
      <p
        className={`${commonColStyle} ${colNameClass} 
        
        `}
        style={colStyle}
      >
        {colName}
      </p>
    </div>
  );

  return [
    {
      name: (
        <HeaderCommonFormat
          colName="Bank Name"
          passclass="text-left w-40 ml-3"
        />
      ),
      selector: 'bankName',
      sortable: false,
      cell: row => {
        return (
          <p className={`${commonStyle} text-left`}>
            {row?.bankName ? row?.bankName : '---'}
          </p>
        );
      },
      maxWidth: '192px !important'
    },

    {
      name: (
        <HeaderCommonFormat
          colName="Product Group"
          passclass="text-left w-40 ml-3"
        />
      ),
      selector: 'productGroup',
      sortable: false,
      cell: row => {
        return (
          <p className={`${commonStyle} text-left`}>
            {row?.productGroup ? row?.productGroup : '---'}
          </p>
        );
      },
      maxWidth: '192px !important'
    },
    {
      name: (
        <HeaderCommonFormat
          colName="Loan Product"
          passclass="text-left w-32 ml-3"
        />
      ),
      selector: 'loanProduct',
      sortable: false,
      cell: row => {
        return (
          <p className={`${commonStyle} text-left`}>
            {row?.loanProduct ? row?.loanProduct : '---'}
          </p>
        );
      },
      maxWidth: '192px !important'
    },
    {
      name: (
        <HeaderCommonFormat
          colName="Total Amount In Group"
          passclass="text-right w-24 -ml-5"
        />
      ),
      selector: 'totalAmountInProductGroup',
      sortable: false,
      cell: row => (
        <p
          style={{
            minWidth: '100px'
          }}
          className={`${commonStyle}  text-right -ml-3`}
        >
          <span className="mr-1"> &#8377;</span>
          {formatNumWithDecimal(row?.totalAmountInProductGroup) || 0}
        </p>
      ),
      maxWidth: '100px !important'
    },

    {
      name: (
        <HeaderCommonFormat
          colName="Total Amount Per Product"
          passclass="text-right w-24 ml-5"
        />
      ),
      selector: 'totalAmountPerProduct',
      sortable: false,
      cell: row => (
        <p
          style={{
            minWidth: '100px'
          }}
          className={`${commonStyle}  text-right`}
        >
          <span className="mr-1"> &#8377;</span>
          {formatNumWithDecimal(row?.totalAmountPerProduct) || 0}
        </p>
      ),
      maxWidth: '100px !important'
    },

    {
      name: (
        <HeaderCommonFormat colName="Slab " passclass="text-right w-40 pr-5" />
      ),
      selector: 'disbursedAmount',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle}  break-normal text-right `}>
          <span className="ml-1">
            {(row?.minSlab || 0) / 10000000 +
              '-' +
              (row?.maxSlab || 0) / 10000000 +
              ' CR'}
          </span>
        </p>
      ),
      maxWidth: '150px !important'
    },
    {
      name: (
        <HeaderCommonFormat
          passclass="text-right w-28"
          colName="Commission Percentage"
        />
      ),
      selector: 'commissionPercentage',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle} break-normal text-right `}>
          <span className="ml-1">{row?.commissionPercentage + '%' || 0}</span>
        </p>
      ),
      maxWidth: '150px !important'
    },
    {
      name: (
        <HeaderCommonFormat passclass="text-right w-28" colName="Expected GR" />
      ),
      selector: 'expectedGR',
      sortable: false,
      cell: row => (
        <p className={`${commonStyle} break-normal text-right `}>
          <span className="mr-1"> &#8377;</span>
          <span>{formatNumWithDecimal(row?.expectedGR) || 0}</span>
        </p>
      ),
      maxWidth: '150px !important'
    }
  ];
};

export default BankSlabColumnData;
